import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { formatRs } from "@/lib/i18n";

const inputCls = "w-full bg-[#050B14] border border-white/15 px-3 py-2.5 outline-none focus:border-[#D4AF37] transition-colors duration-300";

export default function ApproveDialog({ open, onOpenChange, defaultPct, onSubmit }) {
  const [price, setPrice] = useState("25000");
  const [pct, setPct] = useState(defaultPct);
  const [note, setNote] = useState("");
  useEffect(() => { if (open) setPct(defaultPct); }, [open, defaultPct]);
  const deposit = Math.round((Number(price) || 0) * (Number(pct) || 0) / 100);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0A1325] border-[#D4AF37]/40 rounded-none" data-testid="approve-dialog">
        <DialogHeader><DialogTitle className="font-display text-3xl">Accepter la demande</DialogTitle></DialogHeader>
        <div className="space-y-4 text-sm">
          <label className="block"><span className="text-slate-400">Prix total (Rs)</span>
            <input type="number" min={1} value={price} onChange={(e) => setPrice(e.target.value)} className={inputCls} data-testid="approve-price-input" /></label>
          <label className="block"><span className="text-slate-400">Acompte (%)</span>
            <input type="number" min={1} max={100} value={pct} onChange={(e) => setPct(e.target.value)} className={inputCls} data-testid="approve-pct-input" /></label>
          <p>Acompte demandé : <strong className="text-[#D4AF37]" data-testid="approve-deposit-preview">{formatRs(deposit)}</strong></p>
          <label className="block"><span className="text-slate-400">Message au client (facultatif)</span>
            <textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} className={inputCls} data-testid="approve-note-input" /></label>
        </div>
        <DialogFooter>
          <button onClick={() => onSubmit({ price_total: Number(price), deposit_pct: Number(pct), note })} data-testid="approve-confirm-btn"
            disabled={!(Number(price) > 0 && Number(pct) >= 1 && Number(pct) <= 100)}
            className="bg-[#D4AF37] text-[#050B14] px-6 py-3 font-medium hover:bg-[#e6c55a] disabled:opacity-50 transition-colors duration-300">
            Accepter et envoyer au client
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
